import React from 'react';

const HighlightedText = ({ text, highlights = [] }) => {
  if (!highlights.length || !text) {
    return <span>{text}</span>;
  }

  // Create a regex pattern that matches any of the highlight phrases
  const escapedPhrases = highlights.map(phrase => 
    phrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  );
  const pattern = `(${escapedPhrases.join('|')})`;
  const regex = new RegExp(pattern, 'gi');

  const parts = text.split(regex);

  return (
    <span>
      {parts.map((part, i) => {
        const isMatch = highlights.some(phrase => 
          part.toLowerCase() === phrase.toLowerCase()
        );
        return isMatch ? (
          <mark key={i} className="bg-yellow-200 rounded px-0.5">
            {part}
          </mark>
        ) : (
          <span key={i}>{part}</span>
        );
      })}
    </span>
  );
};

export default HighlightedText;
